/** 67.20 (a): the Lab's team distance — its suggestions and its parse (shared by the rows and the parser). */
/** 67.20 (a): the team distance's suggestions (person-heights apart; any whole number 10–2000 can be typed). */
export const FRONT_CHOICES = ['auto', '40', '60', '94', '150', '250'] as const;

/** 'auto', or a whole number of person-heights between 10 and 2000 (anything else reads as 'auto'). */
export function frontOf(v: unknown): string {
  const n = typeof v === 'number' ? v : typeof v === 'string' && v.trim() !== '' && v.trim() !== 'auto' ? Number(v) : NaN;
  return Number.isFinite(n) && n >= 10 && n <= 2000 ? String(Math.round(n)) : 'auto';
}
